var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useIsPhone } from '../../../utilities/hooks/isPhone';
import { Image } from '../Image/Image';
export const ImageFromCdn = (_a) => {
    var { src } = _a, props = __rest(_a, ["src"]);
    const [originAndPath, alignment = 'center'] = src.split('|');
    const [origin, path] = originAndPath.split(':');
    const allowedOrigins = ['assets-cdn'];
    const allowedAlignments = ['left', 'center', 'right'];
    const imageAlign = allowedAlignments.includes(alignment)
        ? alignment
        : 'center';
    const isPhone = useIsPhone();
    const imgPath = isPhone ? `mobile-${path}` : `default-${path}`;
    if (allowedOrigins.includes(origin)) {
        return (React.createElement(Image, Object.assign({}, props, { src: `https://${origin}.moneyfarm.com/images/${imgPath}`, align: imageAlign })));
    }
    return null;
};
//# sourceMappingURL=index.js.map